import React from "react";
import { Typewriter } from "react-simple-typewriter";

function HeroSection() {
  // Scroll to a specific section by ID
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-indigo-600 via-purple-500 to-pink-500 text-white relative overflow-hidden px-4">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-white bg-opacity-20 rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white bg-opacity-20 rounded-full blur-3xl transform translate-x-1/3 translate-y-1/3"></div>
      <div className="absolute top-1/3 left-1/2 w-48 h-48 bg-indigo-400 bg-opacity-30 rounded-full blur-2xl transform -translate-x-1/2 -translate-y-1/2"></div>

      {/* Logo */}
      <img src="/logoblack.png" alt="Logo" className="w-48 h-48 sm:w-64 sm:h-64 mb-6 z-10" />

      {/* Headline with Typewriter Effect */}
      <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-center z-10 break-words">
        <Typewriter
          words={["Chiranthan Enterprises", "Innovation Redefined", "Excellence Across Industries"]}
          loop
          cursor
          cursorStyle="|"
          typeSpeed={80}
          deleteSpeed={50}
          delaySpeed={1000}
        />
      </h1>

      {/* Subheadline */}
      <p className="mt-4 text-lg sm:text-xl text-center max-w-3xl leading-relaxed z-10">
        Leading the future across technology, real estate, fashion, and more with unparalleled dedication and vision.
      </p>

      {/* CTA Buttons */}
      <div className="mt-8 flex flex-col sm:flex-row gap-4 z-10">
        <button
          onClick={() => scrollToSection("ventures-section")}
          className="w-full sm:w-auto px-8 py-4 bg-white text-indigo-600 font-bold text-lg rounded-full shadow-lg hover:bg-gray-100 hover:scale-105 transition-transform"
        >
          Explore Our Ventures
        </button>
        <button
          onClick={() => scrollToSection("contact-section")}
          className="w-full sm:w-auto px-8 py-4 bg-indigo-800 text-white font-bold text-lg rounded-full shadow-lg hover:bg-indigo-700 hover:scale-105 transition-transform"
        >
          Contact Us
        </button>
      </div>
    </div>
  );
}

export default HeroSection;
